import AuthorCard from './AuthorCard';
import { Author } from '../data/authors';

const AuthorGrid = ({ authors }: { authors: Author[] }) => {
  return (
    <section className="author-grid" aria-live="polite">
      {authors.map((author) => (
        <AuthorCard key={author.id} author={author} />
      ))}
    </section>
  );
};

export default AuthorGrid;
